/**
 * 判断是否支持webp格式的图片
 */
const SupportWebpImage = (function () {
  var support = true
  var d = document
  try {
    var el = d.createElement('object')
    el.type = 'image/webp'
    el.innerHTML = '!'
    d.body.appendChild(el)
    support = !el.offsetWidth
    d.body.removeChild(el)
  } catch (err) {
    support = false
  }
  return support
})()

/**
 * 检测浏览器
 * @type {{versions: {trident, presto, webKit, gecko, mobile, ios, android, iPhone, iPad, webApp}, language: string}}
 */
export const browser = {
  versions: (function () {
    var u = navigator.userAgent, app = navigator.appVersion
    return {// 移动终端浏览器版本信息
      trident: u.indexOf('Trident') > -1, // IE内核
      presto: u.indexOf('Presto') > -1, // opera内核
      webKit: u.indexOf('AppleWebKit') > -1, // 苹果、谷歌内核
      gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1, // 火狐内核
      mobile: !!u.match(/AppleWebKit.*Mobile.*/) || !!u.match(/AppleWebKit/), // 是否为移动终端
      ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), // ios终端
      android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1, // android终端或者uc浏览器
      iPhone: u.indexOf('iPhone') > -1 || u.indexOf('Mac') > -1, // 是否为iPhone或者QQHD浏览器
      iPad: u.indexOf('iPad') > -1, // 是否iPad
      webApp: u.indexOf('Safari') == -1 // 是否web应该程序，没有头部与底部
    }
  }()),
  language: (navigator.browserLanguage || navigator.language).toLowerCase()
}

/**
 * 得到Url参数值
 * @param name
 * @returns {*}
 */
export function getQueryString (name, url) {
  var reg = new RegExp('(^|&|\\?)' + name + '=([^&]*)(&|$)', 'i')
  var r = url || window.location.search
  r = r.substr(1).match(reg)
  if (r != null) return unescape(r[2])
  return null
}

/**
 * 去除URL里面的参数
 * @param inputUrl
 * @param splitKeyList
 * @returns {string}
 */
export function getHrefWithSplitKey (inputUrl, splitKeyList) {
  var sHref = inputUrl
  var sharpValue = sHref.split('#')[1]
  sHref = sHref.split('#')[0]
  var args = sHref.split('?')
  var baseUrl = args[0] + '?'
  var str = args[1]
  var isFirstParam = true
  if (str) {
    args = str.split('&')
  } else {
    args = []
  }
  for (var i = 0; i < args.length; i++) {
    str = args[i]
    var arg = str.split('=')
    // 属性参数没有负值
    if (arg.length <= 1) continue
    // 检查是否为需要切除的属性参数
    if (splitKeyList && splitKeyList.indexOf(arg[0]) != -1) {
      continue
    }
    if (isFirstParam) {
      baseUrl = baseUrl + arg[0] + '=' + arg[1]
      isFirstParam = false
    } else {
      baseUrl = baseUrl + '&' + arg[0] + '=' + arg[1]
    }
  }
  if (sharpValue) {
    baseUrl = baseUrl + '#' + sharpValue
  }
  return baseUrl
}

/**
 * 设置协议头为http
 * @param url
 * @returns {*}
 */
export function setUrlProtocolHttp (url) {
  if (!url) {
    return ''
  }
  if (url.indexOf('//') === 0) {
    url = 'http:' + url
  } else {
    url = url.replace(/^https/, 'http')
  }
  return url
}

/**
 * 根据应用内外的参数，格式化link的头
 * @param inputLink
 * @param isInApp
 * @returns {*}
 */
export function formatLinkUrl (inputLink, isInApp) {
  if (isInApp) {
    inputLink = inputLink.replace('https://', 'cyzs://').replace('http://', 'cyzs://')
  } else {
    inputLink = inputLink.replace('cyzs://', 'https://')
  }
  return inputLink
}

/**
 * 格式化dfsUrl
 * @param inputURL
 * @returns {string}
 */
export function formatDFSUrl (inputURL, isHttp) {
  // 已经有http头的话，就不补全路径
  if (inputURL && !inputURL.match('http://') && !inputURL.match('https://') && !inputURL.match('//')) {
    if (isHttp) {
      inputURL = process.env.VUE_APP_IMGCDN + inputURL
      inputURL = inputURL.replace('https', 'http')
    } else {
      inputURL = process.env.VUE_APP_IMGCDN + inputURL
    }
  }
  // 添加协议头
  if (inputURL && inputURL.toString().indexOf('//') == 0) {
    if (isHttp) {
      inputURL = location.protocol + inputURL
      inputURL = inputURL.replace('https', 'http')
    } else {
      inputURL = location.protocol + inputURL
    }
  }

  return inputURL
}

/**
 * 格式化图片CDN URL
 * @param imageCdn
 * @param url
 * @returns {*}
 */
export function formatImageCdnUrl (imageCdn, url) {
  if (url.indexOf(imageCdn) > -1 || url.indexOf('http') > -1) {
    return url
  }
  if (imageCdn.substr(imageCdn.length - 1, 1) != '/') {
    imageCdn = imageCdn + '/'
  }
  if (url.substr(0, 1) == '/') {
    url = url.substr(1, url.length - 1)
  }
  return `${imageCdn}${url}`
}

/**
 * 获取所有的qs
 * @param url
 * @returns {{}}
 */
export function getAllQueryParams (url) {
  try {
    let result = url.match(new RegExp('[\?\&][^\?\&]+=[^\?\&]+', 'g'))
    if (result == null) {
      return {}
    }
    let queryList = {}
    for (let i = 0; i < result.length; i++) {
      let item = result[i].substring(1)
      let keyVal = item.split('=')
      queryList[keyVal[0]] = keyVal[1]
    }
    return queryList
  } catch (e) {
    return {}
  }
}

/**
 * 检查是否为ICY链接
 * @returns {boolean}
 */
export function isCheckIcy () {
  if (getQueryString('appId') == 3) {
    return true
  }
  return true
}

/**
 * 格式化IcyUrl
 * @param url
 * @param childrenParam
 * @returns {*}
 */
export function setIcyUrl (url, childrenParam) {
  if (url.indexOf('?') > -1 || childrenParam) {
    url += '&appId=3'
  } else {
    url += '?appId=3'
  }
  return url
}

/**
 * 七牛图片
 * 指定新宽度为 700px
 * cdn-url?imageMogr2/thumbnail/700x/interlace/1
 */
export function formatQiniuImageByWidth (url, w) {
  if (!url) {
    return ''
  }
  if (w) {
    url = `${url}?imageMogr2/thumbnail/${w}x/interlace/1`
  }
  return formatDFSUrl(url)
}

/**
 * 格式化七牛图片
 * @param url
 * @param width
 * @param height
 * @returns {string} cdn-url?imageMogr2/thumbnail/700x/interlace/1
 */
export function formatImageByQiniu (url, width, height, compress, ignoreHeight, ignoreWidth, formatJpg) {
  if (!url) {
    return ''
  }
  if (!compress) {
    compress = 1
  }
  if (url.indexOf('?imageMogr2/thumbnail') > -1) {
    return url
  }
  // 检测是否支持webp图片格式
  let format = ''
  if (formatJpg) {
    format = '/format/jpg'
  } else if (SupportWebpImage) {
    format = '/format/webp'
  }
  if (width && height) {
    if (ignoreHeight) {
      url = `${url}?imageMogr2/thumbnail/${width * compress}x${format}/interlace/1`
    } else if (ignoreWidth) {
      url = `${url}?imageMogr2/thumbnail/x${height * compress}${format}/interlace/1`
    } else {
      url = `${url}?imageMogr2/thumbnail/${width * compress}x${height * compress}${format}/interlace/1`
    }
  } else if (width) {
    url = `${url}?imageMogr2/thumbnail/${width * compress}x${format}/interlace/1`
  } else if (height) {
    url = `${url}?imageMogr2/thumbnail/x${height * compress}${format}/interlace/1`
  } else {
    url = `${url}?imageMogr2/thumbnail/${600 * compress}x${format}/interlace/1`
  }
  return formatDFSUrl(url)
}

/**
 * 判断是否支持webp格式的图片
 */
export function checkSupportWebpImage () {
  return SupportWebpImage
}

/**
 * url decode方法,解决获取中文问题
 * @param str
 * @param charset
 * @param callback
 */
export function urlDecode (str, charset, callback) {
  charset = charset || 'utf-8'
  var script = document.createElement('script')
  script.id = '_urlDecodeFn_'
  window._urlDecodeFn_ = callback
  if (document.all) {
    if (navigator.userAgent.indexOf('MSIE 8') > -1) {
      // 对于ie8做特别hack
      var link = document.createElement('link')
      link.rel = 'stylesheet'
      link.type = 'text/css'
      link.charset = charset
      link.href = 'data:text/plain;charset=' + charset + ',%23_decode_hidden_el_for_test_%7Bbackground-image%3Aurl(' + str + ')%7D'
      alert(link.href)
      document.body.appendChild(link)
      // 然后创建一个隐藏的div，应用这个样式
      var div = document.createElement('div')
      div.id = '_decode_hidden_el_for_test_'
      div.style.display = 'none'
      document.body.appendChild(div)
      setTimeout(function () {
        callback(document.getElementById('_decode_hidden_el_for_test_').currentStyle['backgroundImage'].match(/\("data\:text\/(.+)"\)/)[1])
        link.parentNode.removeChild(link)
        div.parentNode.removeChild(div)
      }, 300)
    } else {
      // 隐藏iframe截获提交的字符串
      if (!window['_urlDecode_iframe_']) {
        var iframe
        if (document.all) {
          try {
            iframe = document.createElement('<iframe name="_urlDecode_iframe_"></iframe>')
          } catch (e) {
            iframe = document.createElement('iframe')
            // iframe.name = '_urlDecode_iframe_';
            iframe.setAttribute('name', '_urlDecode_iframe_')
          }
        } else {
          iframe = document.createElement('iframe')
          // iframe.name = '_urlDecode_iframe_';
          iframe.setAttribute('name', '_urlDecode_iframe_')
        }
        // iframe.name = '_urlDecode_iframe_';
        iframe.setAttribute('name', '_urlDecode_iframe_')
        iframe.style.display = 'none'
        iframe.width = '0'
        iframe.height = '0'
        iframe.scrolling = 'no'
        iframe.allowtransparency = 'true'
        iframe.frameborder = '0'
        iframe.src = 'about:blank'
        document.body.appendChild(iframe)
      }
      // ie下需要指明charset，然后src=datauri才可以
      iframe.contentWindow.document.write('<html><scrip' + 't charset="gbk" src="data:text/javascript;charset=gbk,parent._decodeStr_=\'' + str + '\'"></s' + 'cript></html>')
      setTimeout(function () {
        callback(_decodeStr_)
        iframe.parentNode.removeChild(iframe)
      }, 300)
    }
  } else {
    var src = 'data:text/javascript;charset=' + charset + ',_urlDecodeFn_("' + str + '");'
    src += 'document.getElementById("_urlDecodeFn_").parentNode.removeChild(document.getElementById("_urlDecodeFn_"));'
    script.src = src
    document.body.appendChild(script)
  }
}

export function getImageSize (url) {
  return new Promise((resolve, reject) => {
    let img = new Image()
    img.src = url
    img.onload = () => {
      img.height = img.naturalHeight
      img.width = img.naturalWidth
      resolve(img)
    }
    img.onerror = () => {
      reject()
    }
  })
}
